'use client';

import { Box, BoxProps, Container, ContainerProps } from '@chakra-ui/react';

interface PageHeroProps extends BoxProps {
  containerProps?: ContainerProps;
}

export function PageHero({ children, containerProps, ...props }: PageHeroProps) {
  return (
    <Box backgroundColor="palePeach" {...props}>
      <Container
        maxW="1440px"
        px={{ mobile: '4', desktop: '10' }}
        pb={{ mobile: '10', desktop: '20' }}
        {...containerProps}
      >
        {children}
      </Container>
    </Box>
  );
}
